// extracted by mini-css-extract-plugin
export default {"view":"client-components-schemaDetail-___schemaDetail__view___3A3o1","preview":"client-components-schemaDetail-___schemaDetail__preview____AXFA"};